import { useEffect } from 'react';
import HeaderV2 from './HeaderV2';
import ErrorBoundary from '../../common/ErrorBoundary';
import '../styles/v2.css';

function Layout({ children }) {
    useEffect(() => {
        console.log('Layout 컴포넌트가 마운트되었습니다.');
    }, []);

    return (
        <div 
            className="v2-layout"
            style={{
                width: '100%',
                maxWidth: '1920px',
                margin: '0 auto',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                background: '#f9fafb',
                position: 'relative'
            }}
        >
            <HeaderV2 />
            <div
                id="v2-contents"
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'calc(100vh - 60px)',
                    maxHeight: '920px'
                }}
            >
                <ErrorBoundary>
                    {children}
                </ErrorBoundary>
            </div>
        </div>
    );
}

export default Layout;
